import { botChatAccent, botColors } from "@rakazo/ui-tokens";
import { appName } from "../lib/branding";
import { AppMark } from "./AppMark";

export function SharedBotHead({
  color,
  className = "size-10",
}: {
  color?: string | null;
  className?: string;
}) {
  return (
    <AppMark className={className} tint={color}>
      <span
        aria-hidden="true"
        className={`${className} grid shrink-0 place-items-center rounded-full bg-muted font-semibold`}
        style={{ color: color ?? undefined }}
      >
        {appName.charAt(0)}
      </span>
    </AppMark>
  );
}
export function SharedBotAppearance({
  color,
  onChange,
}: {
  color?: string | null;
  onChange: (color: string | null) => void;
}) {
  return (
    <fieldset className="space-y-3">
      <legend className="text-sm">Appearance</legend>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          aria-pressed={!color}
          onClick={() => onChange(null)}
          className={`h-9 rounded-lg border px-3 text-sm ${!color ? "border-primary bg-muted" : "border-border"}`}
        >
          Normal
        </button>
        {botColors.map((value, index) => (
          <button
            key={value}
            type="button"
            aria-label={`Color ${index + 1}`}
            aria-pressed={color === value}
            onClick={() => onChange(value)}
            className={`size-9 rounded-full border-2 ${color === value ? "border-primary ring-2 ring-offset-2 ring-offset-background ring-border" : "border-transparent"}`}
            style={{ backgroundColor: value }}
          />
        ))}
      </div>
      <div className="flex items-center gap-3 rounded-xl bg-muted/40 p-4">
        <SharedBotHead color={color} />
        <div
          className="rounded-2xl border border-border px-4 py-3 text-sm"
          style={
            color
              ? { backgroundColor: `color-mix(in srgb, ${botChatAccent(color)} 18%, transparent)` }
              : undefined
          }
        >
          How can I help?
        </div>
      </div>
    </fieldset>
  );
}
